import { render } from "./Stamoulis.vue?vue&type=template&id=0fbea5d3"
import script from "./Stamoulis.vue?vue&type=script&lang=js"
export * from "./Stamoulis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__